<mat-form-field appearance="fill" style="width: 100%">
  <mat-label>{{ time.label }}</mat-label>

  <input
    matInput
    [formControl]="control"
    [placeholder]="time.label"
    [mtxDatetimepicker]="timePicker"
    (click)="timePicker.open()"
    readonly
    required="{{ time.isRequired }}"
  />

  <button mat-icon-button matSuffix (click)="timePicker.open()" type="button">
    <mat-icon>access_time</mat-icon>
  </button>

  <mtx-datetimepicker
    #timePicker
    type="time"
    startView="clock"
    color="primary"
    mode="portrait"
    [twelvehour]="true"
    [touchUi]="false"
  ></mtx-datetimepicker>

  <!-- Required error -->
  @if (control.hasError('required')) {
  <mat-error>
    {{ time.label }}&nbsp;{{
      'workflow.request-document.basic-details.required-error' | translate
    }}
  </mat-error>
  }

  <!-- Past time not allowed -->
  @if (control.hasError('pastDateNotAllowed')) {
  <mat-error>
    {{ 'common.error.past-time-not-allowed' | translate }}
  </mat-error>
  }

  <!-- Future time not allowed -->
  @if (control.hasError('futureDateNotAllowed')) {
  <mat-error>
    {{ 'common.error.future-time-not-allowed' | translate }}
  </mat-error>
  }
</mat-form-field>
